module.exports = __webpack_public_path__ + "img/0Q3A7692_L_Wood_MockedUp.010b2671.jpg";